import React from 'react'
import { Field } from 'redux-form'
import { Dropdown } from 'semantic-ui-react'

import { ComponentContainer } from '../../StyledComponents'

const getDropDownOnChange =
  (storeOnChange) =>
  (e, { value }) =>
    storeOnChange(value)

const FieldComponent = ({
  input: { value, onChange, name },
  options,
  disabled,
  openOnFocus,
  floatLeft,
  upward,
  maxHeight,
}) => {
  return (
    <ComponentContainer dropdown floatLeft={floatLeft}>
      {upward ? (
        <Dropdown
          name={name}
          options={options}
          value={value}
          onChange={getDropDownOnChange(onChange)}
          disabled={disabled}
          openOnFocus={openOnFocus}
          selection
          search
          fluid
          upward
          style={{ maxHeight }}
        />
      ) : (
        <Dropdown
          name={name}
          options={options}
          value={value}
          onChange={getDropDownOnChange(onChange)}
          disabled={disabled}
          openOnFocus={openOnFocus}
          selection
          search
          fluid
          style={{ maxHeight }}
        />
      )}
    </ComponentContainer>
  )
}

const DropdownField = ({ name, onChange, ...restProps }) => (
  <Field name={name} onChange={onChange} {...restProps} component={FieldComponent} />
)

export default DropdownField
